<template>
  <span class="member-stack">
    <MemberAvatar v-for="m in shown" :key="m.id" :member="m" :size="size" class="stack-item" />
    <span v-if="rest > 0" class="stack-more">+{{ rest }}</span>
  </span>
</template>

<script>
import MemberAvatar from './MemberAvatar.vue'

export default {
  name: 'MemberStack',
  components: { MemberAvatar },
  props: {
    members: { type: Array, default: () => [] },
    max: { type: Number, default: 4 },
    size: { type: Number, default: 22 }
  },
  computed: {
    shown () {
      return this.members.slice(0, this.max)
    },
    rest () {
      return Math.max(0, this.members.length - this.max)
    }
  }
}
</script>

<style scoped>
.member-stack {
  display: inline-flex;
  align-items: center;
}
.stack-item {
  margin-left: -6px;
  border: 2px solid #fff;
}
.stack-item:first-child { margin-left: 0; }
.stack-more {
  margin-left: 4px;
  font-size: 11px;
  color: var(--color-text-dim);
}
</style>
